module.exports = __webpack_public_path__ + "img/icon5.9f5d99d8.png";